/* eslint-disable max-lines-per-function */
export interface SetupProjectFacts {
  vesselName?: string | null;
  shipyardName?: string | null;
  hullNumber?: string | null;
  vesselType?: string | null;
  estimatedLengthM?: number | null;
  contractualDeliveryDate?: string | null;
  flagState?: string | null;
  classSociety?: string | null;
}

export interface SetupReadinessStep {
  id: string;
  label: string;
  done: boolean;
  detail: string;
  blocksOperation: boolean;
}

export function buildSetupReadiness(project: SetupProjectFacts | null | undefined) {
  const steps: SetupReadinessStep[] = [
    {
      id: 'vessel',
      label: 'Vessel identity',
      done: Boolean(project?.vesselName && project?.vesselType),
      detail: 'Name/build identity and vessel type.',
      blocksOperation: true,
    },
    {
      id: 'yard',
      label: 'Yard identity',
      done: Boolean(project?.shipyardName && project?.hullNumber),
      detail: 'Shipyard and hull/build number.',
      blocksOperation: true,
    },
    {
      id: 'delivery',
      label: 'Delivery baseline',
      done: Boolean(project?.contractualDeliveryDate),
      detail: 'Planned delivery date.',
      blocksOperation: true,
    },
    {
      id: 'particulars',
      label: 'Particulars',
      done: Boolean(project?.estimatedLengthM),
      detail: 'Estimated length for early filtering and setup suggestions.',
      blocksOperation: false,
    },
    {
      id: 'optional-governance',
      label: 'Optional governance',
      done: Boolean(project?.flagState || project?.classSociety),
      detail: 'Flag or Class captured when known.',
      blocksOperation: false,
    },
  ];

  const done = steps.filter((step) => step.done).length;
  const blockingSteps = steps.filter((step) => step.blocksOperation);
  const blockingDone = blockingSteps.filter((step) => step.done).length;
  return {
    steps,
    done,
    total: steps.length,
    blockingDone,
    blockingTotal: blockingSteps.length,
    percent: Math.round((done / steps.length) * 100),
    operationReady: blockingDone === blockingSteps.length,
    complete: done === steps.length,
  };
}
